import { render, staticRenderFns } from "./ckeditor4.vue?vue&type=template&id=75b5f896"
import script from "./ckeditor4.vue?vue&type=script&lang=js"
export * from "./ckeditor4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports